import { getFormFieldData } from "./formFieldData/formFieldData";
import { deadlineTemplatesFormFieldMapping } from "../../../deadlineTemplates/deadlineTemplatesComponents/DeadlineTemplatesFormFieldMapping";

/**
 * Validates form fields and returns validation issues
 * @param {object} doc - The document object
 * @param {object} transaction - The transaction object
 * @returns {array} Array of validation issues
 */
export function validateFormFields(doc, transaction) {
  const formFieldData = getFormFieldData(doc.title, transaction);
  const formFieldValues = doc.formFieldValues || {};
  const issues = [];

  if (!formFieldData || formFieldData.length === 0) {
    return issues;
  }

  // Group radio button fields by their group name
  const radioButtonGroups = {};
  const textFields = [];
  const textareaFields = [];

  formFieldData.forEach((field) => {
    if (field.name && field.name.startsWith("Radiobutton")) {
      // Extract the group name (second word after "Radiobutton")
      const nameParts = field.name.split(" ");
      if (nameParts.length >= 2) {
        const groupName = nameParts[1];
        if (!radioButtonGroups[groupName]) {
          radioButtonGroups[groupName] = [];
        }
        radioButtonGroups[groupName].push(field);
      }
    } else if (field.type === "text") {
      textFields.push(field);
    } else if (field.type === "textarea") {
      textareaFields.push(field);
    }
  });

  // Validate radio button groups
  Object.entries(radioButtonGroups).forEach(([groupName, fields]) => {
    const selectedFields = fields.filter((field) => {
      const value = formFieldValues[field.name];
      return value === true || value === "true" || value === "on";
    });

    if (selectedFields.length === 0) {
      // No radio button selected in this group
      const firstField = fields[0];
      issues.push({
        type: "radiogroup",
        groupName: groupName,
        message: "none selected",
        field: firstField,
        fields: fields,
      });
    } else if (selectedFields.length > 1) {
      // Multiple radio buttons selected in this group
      const firstField = fields[0];
      issues.push({
        type: "radiogroup",
        groupName: groupName,
        message: "multiple selected (only one allowed)",
        field: firstField,
        fields: fields,
        selectedFields: selectedFields,
      });
    }
  });

  // Validate text fields
  textFields.forEach((field) => {
    const value = formFieldValues[field.name];
    if (!value || value.trim() === "") {
      issues.push({
        type: "text",
        message: "field is blank",
        field: field,
      });
    }
  });

  // Validate textarea fields
  textareaFields.forEach((field) => {
    const value = formFieldValues[field.name];
    if (!value || value.trim() === "") {
      issues.push({
        type: "textarea",
        message: "field is blank",
        field: field,
      });
    }
  });

  // Validate mutual exclusivity for deadline template mapped fields
  Object.entries(deadlineTemplatesFormFieldMapping).forEach(([textFieldName, dateFieldName]) => {
    const textValue = formFieldValues[textFieldName];
    const dateValue = formFieldValues[dateFieldName];

    const textHasValue = textValue && textValue.trim() !== "";
    const dateHasValue = dateValue !== null; //&& dateValue.trim() !== "";

    if (!textHasValue && !dateHasValue) {
      // Both fields are empty
      const textField = formFieldData.find(f => f.name === textFieldName);
      const dateField = formFieldData.find(f => f.name === dateFieldName);

      if (textField) {
        issues.push({
          type: "mutuallyExclusive",
          message: "at least one field should be filled",
          field: textField,
          conflictingField: dateField,
          conflictingFieldName: dateFieldName,
        });
      }
    }
    // if (textHasValue && dateHasValue) {
    //   // Both fields are filled - this is not allowed. actually this is fine
    //   const textField = formFieldData.find(f => f.name === textFieldName);
    //   const dateField = formFieldData.find(f => f.name === dateFieldName);

    //   if (textField) {
    //     issues.push({
    //       type: "mutuallyExclusive",
    //       message: "only one field should be filled (conflicts with date field)",
    //       field: textField,
    //       conflictingField: dateField,
    //       conflictingFieldName: dateFieldName,
    //     });
    //   }

    //   if (dateField) {
    //     issues.push({
    //       type: "mutuallyExclusive",
    //       message: "only one field should be filled (conflicts with text field)",
    //       field: dateField,
    //       conflictingField: textField,
    //       conflictingFieldName: textFieldName,
    //     });
    //   }
    // }
  });

  return issues;
}

/**
 * Groups validation issues by page for easier display
 * @param {array} issues - Array of validation issues
 * @returns {object} Issues grouped by page number
 */
export function groupIssuesByPage(issues) {
  const groupedIssues = {};
  
  issues.forEach((issue) => {
    const page = issue.field.page;
    if (!groupedIssues[page]) {
      groupedIssues[page] = [];
    }
    groupedIssues[page].push(issue);
  });

  return groupedIssues;
}
